import { render } from "./LegacyEmailEditField.vue?vue&type=template&id=4ed703e8"
import script from "./LegacyEmailEditField.vue?vue&type=script&lang=js"
export * from "./LegacyEmailEditField.vue?vue&type=script&lang=js"
script.render = render

export default script